import { InAppReview } from '@capacitor-community/in-app-review';
import { Capacitor } from '@capacitor/core';
import { logInAppReview } from './analytics';

const STORAGE_KEY_SESSIONS = 'mhc_review_sessions';
const STORAGE_KEY_ENGAGEMENTS = 'mhc_review_engagements';
const STORAGE_KEY_LAST_PROMPTED = 'mhc_review_last_prompted';
const STORAGE_KEY_COMPLETED = 'mhc_review_completed';

const MIN_SESSIONS = 3;
const MIN_ENGAGEMENTS = 5;
const COOLDOWN_DAYS_MS = 30 * 24 * 60 * 60 * 1000; // 30 days

export function trackSession(): void {
  try {
    const count = parseInt(localStorage.getItem(STORAGE_KEY_SESSIONS) || '0', 10);
    localStorage.setItem(STORAGE_KEY_SESSIONS, String(count + 1));
  } catch {}
}

export function trackEngagement(actionWeight = 1): void {
  try {
    const count = parseInt(localStorage.getItem(STORAGE_KEY_ENGAGEMENTS) || '0', 10);
    const newCount = count + actionWeight;
    localStorage.setItem(STORAGE_KEY_ENGAGEMENTS, String(newCount));

    // Check if eligible for review prompt
    if (shouldPromptReview()) {
      triggerReviewPrompt();
    }
  } catch {}
}

function shouldPromptReview(): boolean {
  if (!Capacitor.isNativePlatform()) return false;

  try {
    const isCompleted = localStorage.getItem(STORAGE_KEY_COMPLETED) === 'true';
    if (isCompleted) return false;

    const lastPrompted = parseInt(localStorage.getItem(STORAGE_KEY_LAST_PROMPTED) || '0', 10);
    if (Date.now() - lastPrompted < COOLDOWN_DAYS_MS) return false;

    const sessions = parseInt(localStorage.getItem(STORAGE_KEY_SESSIONS) || '0', 10);
    const engagements = parseInt(localStorage.getItem(STORAGE_KEY_ENGAGEMENTS) || '0', 10);

    return sessions >= MIN_SESSIONS || engagements >= MIN_ENGAGEMENTS;
  } catch {
    return false;
  }
}

export async function triggerReviewPrompt(): Promise<void> {
  if (!Capacitor.isNativePlatform()) return;

  try {
    localStorage.setItem(STORAGE_KEY_LAST_PROMPTED, String(Date.now()));
    logInAppReview('prompted');

    await InAppReview.requestReview();

    localStorage.setItem(STORAGE_KEY_COMPLETED, 'true');
    logInAppReview('completed');
  } catch (err) {
    console.warn('[InAppReview] request failed:', err);
    logInAppReview('failed');
  }
}
